/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import DropdownMenu from 'react-dd-menu';

export default class DropDown extends React.Component {
    static get propTypes() {
        return {
            toggle: PropTypes.node.isRequired,
            animate: PropTypes.bool,
            items: PropTypes.arrayOf(PropTypes.node).isRequired,
            align: PropTypes.string,
            className: PropTypes.string,
            setDropDownSate: PropTypes.func
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false
        };
        this.toggle = this.toggle.bind(this);
        this.close = this.close.bind(this);
    }

    toggle(evt) {
        evt.stopPropagation();
        if (this.props.setDropDownSate) {
            this.props.setDropDownSate(!this.state.isMenuOpen);
        }
        this.setState({isMenuOpen: !this.state.isMenuOpen});
    }

    close() {
        this.setState({isMenuOpen: false});
        if (this.props.setDropDownSate) {
            this.props.setDropDownSate(false);
        }
    }

    getChildren(nodes) {
        const children = [];
        nodes.forEach((node, index) => {
            children.push(<li key={index}>{node}</li>);
        });
        return children;
    }

    render() {
        const children = this.getChildren(this.props.items);
        const node = this.props.toggle;
        let menuOptions = {
            isOpen: this.state.isMenuOpen,
            close: this.close,
            toggle: <span onClick={this.toggle}>{node}</span>,
            align: this.props.align || 'left',
            size: this.props.size || 'sm',
            menuAlign: this.props.menuAlign || 'right',
        };
        return <div className={this.props.className}>
            <DropdownMenu {...menuOptions}>
                {children}
            </DropdownMenu>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/DropDown/DropDown.js